<div class="ticket-box" *ngIf="display">
    <ion-icon uppDataid="ticketthumb-client-icon" *ngIf="display.isguest" class="left success" name="person"></ion-icon>

    <ion-item-sliding #slider (ionDrag)="OnSlidingDrag($event)" (ionSwipe)="OnSlidingStart()" (click)="OnSlidingClick($event, slider)">
        <ion-item lines="none">
            <ion-buttons slot="start"> 
                <ng-container *ngIf="display.toprepare">
                    <ion-button uppDataid="ticketthumb-prepare-button" mode="md" color="dark" shape="round" fill="solid"  (click)="PrepareTicket($event)">
                        <ion-icon name="checkmark-circle-outline"></ion-icon> 
                    </ion-button>
                </ng-container>
            </ion-buttons>

            <ion-label uppDataid="ticketthumb-brief-info">
                <span class="elapsed" *ngIf="display.elapsed">{{display.elapsed}}</span><br/>
    
                <!-- ORDER NO -->
                <span class="field order" *ngIf="display.orderno !== null" uppDataid="title-field-orderno">
                    <span><span class="small">#</span>{{display.orderno}}</span>
                </span>
                <span class="field order" *ngIf="display.orderno === null">
                    <ion-spinner name="lines-small"></ion-spinner>  
                </span>
    
                <!-- TABLE NO -->
                <span class="field table" *ngIf="display.tableno === null">
                    <span uppDataid="title-field-tableno" class="small">{{tr('@place_ticket_barticket')}}</span>
                </span>
                <span class="field table" *ngIf="display.tableno !== null">
                    <ng-container *ngIf="display.tablealias !== null">
                        <span uppDataid="title-field-tableno">{{display.tablealias}}</span>
                    </ng-container>
                    <ng-container *ngIf="display.tablealias === null">
                        <span><span class="small">{{tr('@place_ticket_table')}}:</span><span uppDataid="title-field-tableno">{{display.tableno}}</span></span>
                    </ng-container>
                </span>
    
                <!-- PRICE -->
                <span class="field price" *ngIf="display.price !== null">
                    <span uppDataid="title-field-price" style="display: none;">{{display.price.str}}</span>  
                    <span class="price">
                        {{display.price.int}},<span class="small">{{display.price.dec}}</span>{{tr('@currency')}}
                    </span>
                </span>
            </ion-label>

            <!-- PAID STATUS-->
            <ion-label uppDataid="ticketthumb-payment-info" class="top right" color="success" *ngIf="display.ispaid">
                <ion-icon [ngClass]="{'hidden': display.payment !== 'PAYCASH'}" name="cash"></ion-icon>
                <ion-icon [ngClass]="{'hidden': display.payment !== 'PAYCARD'}" name="card"></ion-icon>
                <ion-icon [ngClass]="{'hidden': display.payment !== 'PAYMIXED'}" name="logo-usd"></ion-icon>
                <upp-online-paid-icon [ngClass]="{'hidden': display.payment !== 'PAYLINE'}"></upp-online-paid-icon>
                <ion-icon [ngClass]="{'hidden': display.payment !== 'PAYACCOUNT'}" name="ribbon"></ion-icon>
                {{display.paidon}}
            </ion-label>
    
            <!-- PAYMENT BUTTONS -->
            <ion-buttons slot="end"> 
                <ng-container *ngIf="display.topayment">
                    <ion-button *ngIf="ticket?.place?.CanCash" uppDataid="ticketthumb-paycash-button" mode="md" color="dark" shape="round" fill="outline" [disabled]="!display.cancash" (click)="PayTicket($event, 'PAYCASH')">
                        <ion-icon name="cash"></ion-icon> 
                    </ion-button>
                    <ion-button uppDataid="ticketthumb-paycard-button" mode="md" color="dark" shape="round" fill="outline" [disabled]="!display.cancard" (click)="PayTicket($event, 'PAYCARD')">
                        <ion-icon name="card"></ion-icon> 
                    </ion-button>
                </ng-container>
            </ion-buttons>
        </ion-item>

        <ion-item-options side="end">
            <ion-item-option uppDataid="ticketthumb-print-option" uppTouch
                (TouchClick)="OnPrintClicked($event, slider)"
                (TouchStart)="OnPrintPressed(true)"
                (TouchLeave)="OnPrintPressed(false)"
            >
                <ion-item class="options" lines="none">
                    <ion-button uppDataid="ticketthumb-print-button" mode="md" slot="icon-only" fill="clear" slot="end">
                        <ion-icon color="dark" name="print-outline"></ion-icon>  
                    </ion-button>
                </ion-item>
            </ion-item-option>
        </ion-item-options>    
    </ion-item-sliding>
    
    <ion-icon uppDataid="ticketthumb-request-icon" [hidden]="!display.waiter" class="right warning" name="hand-left-outline" ></ion-icon>
    <ion-icon uppDataid="ticketthumb-cardterm-icon" [hidden]="!display.cardpending" class="right warning" name="alert-circle-outline"></ion-icon>
    <ion-icon uppDataid="ticketthumb-cancelled-icon" [hidden]="!display.cancelled" class="right danger" name="trash-outline"></ion-icon>
    <ion-icon uppDataid="ticketthumb-invoice-icon" [hidden]="!display.invoice" class="right success" name="logo-usd"></ion-icon>
</div>

<upp-dialog *ngIf="PayCashTickets !== null"
    [backdropDismiss]="false"
    style="--upp-dialog-panel-width: 420px"
    (OnClose)="OnPayCashClose()">
    <upp-modal-cashpay
        [tickets]="PayCashTickets"
        (OnAccept)="OnPayCashAccept($event)"
        (OnClose)="OnPayCashClose()">
    </upp-modal-cashpay>
</upp-dialog>

<upp-dialog *ngIf="PayCardTickets !== null"
    [backdropDismiss]="false"
    style="--upp-dialog-panel-width: 420px"
    (OnClose)="OnPayCardClose()">
    <upp-modal-cardpay
        [tickets]="PayCardTickets"
        (OnAccept)="OnPayCardAccept()"
        (OnClose)="OnPayCardClose()">
    </upp-modal-cardpay>
</upp-dialog>

<upp-pinpad-session></upp-pinpad-session>
